export default ({ Vue }) => {
  // eslint-disable-next-line no-extend-native
  String.prototype.toPersianDigits = function (a) {
    return this.replace(/\d+/g, function (b) {
      const c = []
      const d = []
      for (let e = 0; e < b.length; e++) c.push(b.charCodeAt(e))
      for (let f = 0; f < c.length; f++) d.push(String.fromCharCode(c[f] + (a && a === 1 ? 1584 : 1728)))
      return d.join('')
    })
  }

  Vue.filter('to-persian', function (value) {
    if (!value) return value
    return value.toString().replace(/\./g, '٫').toPersianDigits()
  })

  Vue.filter('comma-separate', function (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  })
}
